<template>
  <modal
    :show-modal="true"
    class="modal-razao-fallback"
    :show-header="false"
    :show-footer="false"
    @close="noop"
  >
    <div slot="body">
      <div class="modal-razao-fallback__content">
        <i
          class="mdi mdi-alert-circle-outline modal-razao-fallback__icon"
          aria-hidden="true"
        ></i>
        <h4 id="modal-razao-fallback-title" class="modal-razao-fallback__title">
          Nenhum CNPJ disponível
        </h4>
        <p
          id="modal-razao-fallback-message"
          class="modal-razao-fallback__message"
        >
          No momento, nenhum dos CNPJs vinculados ao seu usuário está ativo.
        </p>
        <p class="modal-razao-fallback__help">
          <small
            >Em caso de dúvida, entre em contato com o responsável pela sua
            empresa ou com o suporte.</small
          >
        </p>
        <button
          ref="logoutButton"
          type="button"
          class="btn btn-primary modal-razao-fallback__button"
          :disabled="isLoggingOut"
          @click="logout"
        >
          <i
            v-if="isLoggingOut"
            class="mdi mdi-loading fa-spin"
            aria-hidden="true"
          ></i>
          <span>{{ isLoggingOut ? "Saindo..." : "Sair" }}</span>
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import modal from "@/components/root/modal/Modal";

export default {
  name: "ModalRazaoFallback",
  components: { modal },
  data() {
    return {
      isLoggingOut: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.logoutButton && this.$refs.logoutButton.focus) {
        this.$refs.logoutButton.focus();
      }
    });
  },
  methods: {
    async logout() {
      if (this.isLoggingOut) return;
      this.isLoggingOut = true;

      const success = await Account.logout();
      if (!success) {
        this.isLoggingOut = false;
      }
    },
    noop() {},
  },
};
</script>

<style lang="scss">
@import "~@/assets/css/sass/bootstrap/variables";

.modal-razao-fallback {
  .modal-container {
    max-width: 590px;
    width: 100%;
    padding-left: 16px;
    padding-right: 16px;
  }

  .modal-wrapper #modal {
    width: 100%;
    border-radius: 12px;
    box-shadow: 0 20px 45px rgba(0, 0, 0, 0.2);
  }

  .modal-body {
    padding: 28px 32px;
  }

  &__content {
    text-align: center;
  }

  &__icon {
    font-size: 40px;
    color: var(--brand-primary, $brand-primary);
    margin-bottom: 12px;
  }

  &__title {
    margin: 0 0 10px;
    font-weight: 700;
    color: #222;
  }

  &__message {
    margin: 0 0 8px;
    color: #444;
  }

  &__help {
    margin: 0 0 20px;
    color: #666;
  }

  &__button {
    min-width: 160px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: filter 0.2s ease, box-shadow 0.2s ease;
  }

  &__button:hover:not(:disabled),
  &__button:focus-visible:not(:disabled) {
    filter: brightness(1.06);
    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.15);
  }

  &__button:disabled {
    cursor: not-allowed;
    opacity: 0.85;
  }
}

@media (max-width: 600px) {
  .modal-razao-fallback {
    .modal-container {
      padding-left: 12px;
      padding-right: 12px;
    }

    .modal-body {
      padding: 22px 20px;
    }
  }
}

@media (max-width: 520px) {
  .modal-razao-fallback {
    .modal-wrapper #modal {
      position: relative;
      height: auto;
    }
  }
}
</style>
